export interface CalcPointProps {
  min: number;
  max: number;
  point: number;
}

export const calcPoint = ({ min, max, point }: CalcPointProps) => {
  const range = max - min;
  return `${(Math.abs(point - min) / range) * 100}%`;
};
